import { getAnalytics, isSupported, logEvent, setAnalyticsCollectionEnabled } from 'firebase/analytics'
import type { Analytics } from 'firebase/analytics'
import { app } from '../lib/firebase'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

let analyticsPromise: Promise<Analytics | null> | null = null

/**
 * Initialiserer Google Analytics 4 én gang via den eksisterende Firebase-konfiguration
 * (measurementId G-NSZDNR48EB). Firebase indsætter selv gtag.js, så scriptet
 * tilføjes aldrig to gange. Er gtag allerede indsat på siden, genbruges det.
 */
export function initAnalytics(): Promise<Analytics | null> {
  if (analyticsPromise) return analyticsPromise

  analyticsPromise = isSupported()
    .then((supported) => {
      if (!supported) return null
      const analytics = getAnalytics(app)
      setAnalyticsCollectionEnabled(analytics, true)
      return analytics
    })
    .catch(() => null)

  return analyticsPromise
}

/** Sender en GA4-event. Fejler stilfærdigt, så sporing aldrig kan blokere brugerflowet. */
export async function trackEvent(name: string, params: Record<string, unknown> = {}): Promise<void> {
  try {
    const analytics = await initAnalytics()
    if (analytics) {
      logEvent(analytics, name, params)
      return
    }
    // Fallback: et gtag-snippet indsat direkte på siden.
    window.gtag?.('event', name, params)
  } catch {
    /* Sporing må aldrig give fejl for brugeren. */
  }
}
